import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';

interface Documento {
  CDOPERADOR?: string;
  DSREFERENCIA: string;
  FILE: string;
  NMANEXO: string;
  NRVINCULOM: string;
}

class DocumentosController {
  public static async getDocumentosVinculo(
    nrVinculo: string,
    nrCategoria: string | null = null,
    showLoading = true
  ) {
    const route = 'getDocumentosVinculo';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      NRCATEGDOCUMENTO: nrCategoria,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const documentos: any[] = response.data.dataset.data;

      return documentos;
    } catch (err) {
      const message = 'Não foi possível carregar os documentos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getCategoriasComDocumentoVinculo(
    nrVinculo: string,
    showLoading = true
  ) {
    const route = 'getCategoriasComDocumentoVinculo';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const categorias: any[] = response.data.dataset.data;

      return categorias;
    } catch (err) {
      const message = 'Não foi possível carregar os documentos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getCategorias(
    showLoading = true,
  ) {
    const route = 'getCategorias';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const categorias: any[] = response.data.dataset.data;

      return categorias;
    } catch (err) {
      const message = 'Não foi possível carregar as categorias!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipos(
    showLoading = true,
  ) {
    const route = 'getTipos';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async downloadDocumento(
    nrAnexo: string,
    showLoading = true,
  ) {
    const route = 'downloadDocumento';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRANEXO: nrAnexo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const file = response.data.dataset.data;

      return file;
    } catch (err) {
      const message = 'Não foi possível baixar o documento!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveDocumento(
    row: any,
    showLoading = true,
  ) {
    const route = 'saveDocumento';
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        ...row,
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const success = response.data.dataset.data;

      return success;
    } catch (err) {
      const message = 'Não foi possível salvar o documento!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveDocumentosQrCode(
    documentos: Documento[],
    showLoading = true,
  ) {
    const route = 'saveDocumentosQrCode';
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        DOCUMENTOS: documentos,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const success = response.data.dataset.data;

      return success;
    } catch (err) {
      const message = 'Não foi possível salvar o documento!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async deleteDocumento(
    nrAnexo: string,
    showLoading = true,
  ) {
    const route = 'deleteDocumento';
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRANEXO: nrAnexo,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const success = response.data.dataset.data;

      const message = 'O documento foi excluído com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return success;
    } catch (err) {
      const message = 'Não foi possível deletar o documento!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveAssinatura(
    row: any,
    showLoading = true,
  ) {
    const route = 'saveAssinatura';
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        ...row,
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      await HttpRequest.post(route, params, showLoading);
      SnackbarUtils.showMessage('Documento enviado ao vínculo para assinatura!');
    } catch (err) {
      const message = 'Não foi possível enviar o documento para assinatura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getIntegracaoDigitalFile(
    nrIntegracaoDigital,
    nrParcNegocio,
    showLoading = true,
  ) {
    const route = 'getIntegracaoDigitalFile';

    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      NRPARCNEGOCIO: nrParcNegocio,
      NRINTELETRDIGIT:  nrIntegracaoDigital
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const fileData: {base64: string, type: string} = response.data.dataset.data;

      return fileData;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async changeStatusAssinatura(
    row: any,
    showLoading = true,
  ) {
    const route = 'changeStatusAssinatura';

    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const success = response.data.dataset.data;

      return success;
    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível aprovar / reprovar a Assinatura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveAssinaturaVinculo(
    documento: any,
    showLoading = true,
  ) {
    const route = 'saveAssinaturaVinculo';

    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        DOCUMENTOS: documento,
        CDOPERADOR: cdOperador,
        NRORG: nrOrg,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const success = response.data.dataset.data;

      return success;
    } catch (err) {
      const message = 'Não foi possível salvar a Assinatura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getAssinaturaByVinculo(
    showLoading = true,
  ) {
    const route = 'getAssinaturaByVinculo';

    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const doc: any = response.data.dataset.data;

      return doc;
    } catch (err) {
      const message = 'Não foi possível carregar a assinatura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async verificaAssinaturaVinculo(
    showLoading = true,
    nrvinculom
  ) {
    const route = 'verificaAssinaturaVinculo';

    const user: User = store.getters.user;

    const nrOrg = user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrvinculom
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const doc: any = response.data.dataset.data;

      return doc;
    } catch (err) {
      const message = 'Não foi possível verificar a assinatura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

}

export default DocumentosController;